module.exports = __webpack_public_path__ + "img/icon-map-pin.f4484d9e.svg";